import React from 'react';
import { Spinner } from '@shopify/polaris';

const LoadingSpinner = () => (<div className='loading-spinner'><Spinner size="large" color="teal" /></div>);

export default LoadingSpinner;
